module.exports = __webpack_public_path__ + "static/media/carousel-3.b45ba0f5.jpg";